import { StorageAdapter } from "./StorageAdapter";

export class BrowserStorageAdapter implements StorageAdapter {
    private storage: Storage;

    constructor() {
        this.storage = window.localStorage;
    }

    getItem( key: string ) {
        try {
            const val = this.storage.getItem( key );
            if ( val ) return JSON.parse( val );
            return val;
        } catch ( err ) {
            console.error( err );
            return null;
        }
    }

    setItem( key: string, value: any ): void {
        try {
            const newValue = JSON.stringify( value );
            this.storage.setItem( key, newValue );
        } catch ( err ) {
            console.error( err );
        }
    }

    removeItem( key: string ): void {
        this.storage.removeItem( key );
    }
}
